import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { fetchAccountDetailsForMenu } from '../api'
import { useLogon } from '@core/Utils/hooks/useLogon'

export const useAccountDetailsQuery = (shouldFetch: boolean) => {
  const { isLoggedIn } = useLogon()

  return useQuery({
    queryKey: queryKeys.accountDetailsForMenu,
    queryFn: fetchAccountDetailsForMenu,
    enabled: Boolean(shouldFetch && isLoggedIn),
    staleTime: 2_000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
